<template>
    <div
      ref="container"
      class="wrapper-component w-full flex items-center justify-center relative"
      :class="[this.wrapperHeight === 'viewport' ? 'min-h-viewport' : null]"
    >
      <div class="z-20 mx-auto w-full flex items-center justify-center" :class="[contentWidthClass]">
        <div class="w-full" :class="[inset ? 'p-10 md:p-16' : 'p-4 md:p-10']">
          <slot></slot>
        </div>
      </div>
  
      <div class="z-10 absolute bg-neutral-950 bg-opacity-70"
           :class="[
             inset ? 'rounded-2xl inset-6' : 'inset-0',
           ]"
           v-if="shouldUseMask"
      ></div>
  
      <div class="z-0 absolute"
           :style="{
             backgroundImage: bgImage ? `url('${bgImage}')` : null,
             backgroundColor: bgColor ? bgColor : null,
           }"
           :class="[
             bgImage ? 'bg-image bg-center bg-cover' : null,
             inset ? 'rounded-2xl inset-6' : 'inset-0',
           ]"
      ></div>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'Wrapper',
    computed: {
      contentWidthClass() {
        const widthMap = {
          sm: 'max-w-screen-sm',
          md: 'max-w-screen-md',
          lg: 'max-w-screen-lg',
          xl: 'max-w-screen-xl',
          '2xl': 'max-w-screen-2xl',
          full: 'w-full',
        };
        return widthMap[this.contentWidth];
      },
      shouldUseMask() {
        return this.useMask || this.bgImage;
      },
    },
    methods: {
  
    },
    props: {
      bgColor: {
        type: String,
        default: 'transparent',
      },
      bgImage: {
        type: String,
        required: false,
      },
      contentWidth: {
        type: String,
        default: 'xl',
        validator(value) {
          return ['sm', 'md', 'lg', 'xl', '2xl', 'full'].includes(value);
        },
      },
      inset: {
        default: false,
        type: Boolean,
      },
      useMask: {
        default: false,
        type: Boolean,
      },
      wrapperHeight: {
        default: false,
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  </style>
  